// Gated top-level pages (mirrors backend PAGE_REGISTRY keys / nav routes).
// Used to enforce custom user-type page access on the frontend.
export const GATED_PAGES = [
  "/dashboard", "/my-designs", "/my-preaudit", "/sub-scope", "/floorplan",
  "/site-install", "/pocket-files", "/design-review", "/print-designs",
  "/preaudit", "/prepress-board", "/psm-procurement", "/production",
  "/prepress", "/drafts", "/scope-po", "/projects", "/clients", "/production-files",
  "/procurement", "/accounts-billing", "/accounts/commercials",
  "/po-followup", "/invoices",
];

// Resolve a pathname to its gated top-level page key (longest prefix match),
// so sub-routes like /projects/MIPL-1 inherit /projects access. Returns "" when
// the path isn't a gated page (e.g. /masters, /users — admin-only by role).
export function pageKeyForPath(pathname) {
  let best = "";
  for (const k of GATED_PAGES) {
    if ((pathname === k || pathname.startsWith(k + "/")) && k.length > best.length) best = k;
  }
  return best;
}

export function firstAllowedPath(allowed) {
  return (allowed && allowed.length) ? allowed[0] : "/";
}
